import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28a257c3")

_pushScopeId("data-v-28a257c3")
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "receipt-type-title mt-lg-4" }
const _hoisted_3 = { class: "d-lg-flex justify-content-lg-center mt-lg-5" }
const _hoisted_4 = { class: "actions-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-receipt-credit-card fs-40" })
], -1)
const _hoisted_6 = { class: "action-text" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-receipt-cash fs-40" })
], -1)
const _hoisted_8 = { class: "action-text" }
const _hoisted_9 = { class: "actions-row" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-receipt-check fs-40" })
], -1)
const _hoisted_11 = { class: "action-text" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-receipt-bank fs-40" })
], -1)
const _hoisted_13 = { class: "action-text" }
const _hoisted_14 = {
  key: 1,
  class: "container payment-container"
}
const _hoisted_15 = { class: "receipt-type-title mt-lg-4" }
const _hoisted_16 = { class: "d-flex justify-content-end" }
const _hoisted_17 = { class: "toggle-label product-details-title" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-6 col-md-3" }
const _hoisted_20 = { class: "pb-1" }
const _hoisted_21 = { class: "col-6 col-md-2" }
const _hoisted_22 = {
  for: "currency",
  class: "pb-1"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "col-6 col-md-3"
}
const _hoisted_25 = { class: "pb-1" }
const _hoisted_26 = { class: "col-6 col-md-4 amount-in-local-currency" }
const _hoisted_27 = { class: "col-12 pt-4" }
const _hoisted_28 = { class: "pb-1" }
const _hoisted_29 = { class: "col-12 pt-4" }
const _hoisted_30 = { class: "pb-1" }
const _hoisted_31 = { class: "col-6 pt-4" }
const _hoisted_32 = { class: "pb-1" }
const _hoisted_33 = { class: "invalid-feedback invalid-feedback-lastFourDigits" }
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_35 = { class: "col-6 pt-4 pb-4" }
const _hoisted_36 = { class: "pb-1" }
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_38 = {
  key: 0,
  class: "multy-invalid-feedback"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_40 = {
  key: 2,
  class: "container payment-container"
}
const _hoisted_41 = { class: "receipt-type-title mt-lg-4" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-6 col-md-3" }
const _hoisted_44 = { class: "pb-1" }
const _hoisted_45 = { class: "col-6 col-md-2" }
const _hoisted_46 = { for: "currency" }
const _hoisted_47 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_48 = {
  key: 0,
  class: "col-6 col-md-3"
}
const _hoisted_49 = { class: "pb-1" }
const _hoisted_50 = { class: "col-6 col-md-4 amount-in-local-currency" }
const _hoisted_51 = {
  key: 3,
  class: "container payment-container"
}
const _hoisted_52 = { class: "receipt-type-title mt-lg-4" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-6 col-md-3" }
const _hoisted_55 = { class: "pb-1" }
const _hoisted_56 = { class: "col-6 col-md-2" }
const _hoisted_57 = { for: "currency" }
const _hoisted_58 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_59 = {
  key: 0,
  class: "col-6 col-md-3"
}
const _hoisted_60 = { class: "pb-1" }
const _hoisted_61 = { class: "col-6 col-md-4 amount-in-local-currency" }
const _hoisted_62 = { class: "col-12 pt-3" }
const _hoisted_63 = { class: "pb-1" }
const _hoisted_64 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_65 = { class: "col-12 pt-3" }
const _hoisted_66 = { class: "pb-1" }
const _hoisted_67 = { class: "col-12 pt-3" }
const _hoisted_68 = { class: "pb-1" }
const _hoisted_69 = { class: "col-12 pt-3" }
const _hoisted_70 = { class: "pb-1" }
const _hoisted_71 = { class: "col-12 pt-3" }
const _hoisted_72 = { class: "pb-1" }
const _hoisted_73 = { class: "invalid-feedback" }
const _hoisted_74 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_75 = { class: "col-12 pt-3 pb-4" }
const _hoisted_76 = { class: "pb-1" }
const _hoisted_77 = {
  key: 4,
  class: "container payment-container"
}
const _hoisted_78 = { class: "receipt-type-title mt-lg-4" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-6 col-md-3" }
const _hoisted_81 = { class: "pb-1" }
const _hoisted_82 = { class: "col-6 col-md-2" }
const _hoisted_83 = { for: "currency" }
const _hoisted_84 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_85 = {
  key: 0,
  class: "col-6 col-md-3"
}
const _hoisted_86 = { class: "pb-1" }
const _hoisted_87 = { class: "col-6 col-md-4 amount-in-local-currency" }
const _hoisted_88 = { class: "col-12 pt-3" }
const _hoisted_89 = { class: "pb-1" }
const _hoisted_90 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_91 = { class: "col-12 pt-3" }
const _hoisted_92 = { class: "pb-1" }
const _hoisted_93 = { class: "col-12 pt-3" }
const _hoisted_94 = { class: "pb-1" }
const _hoisted_95 = { class: "col-12 pt-3" }
const _hoisted_96 = { class: "pb-1" }
const _hoisted_97 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_98 = { class: "col-6 pt-3 pb-4" }
const _hoisted_99 = { class: "pb-1" }
const _hoisted_100 = { class: "invalid-feedback" }
const _hoisted_101 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_102 = { class: "col-6 pt-3 pb-4" }
const _hoisted_103 = { class: "pb-1" }
const _hoisted_104 = { class: "invalid-feedback" }
const _hoisted_105 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_106 = {
  key: 5,
  class: "select-receipt-payment-actions"
}
const _hoisted_107 = {
  class: "payment-action-save",
  type: "submit"
}
const _hoisted_108 = { class: "select-receipt-payment-actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[52] || (_cache[52] = ($event: any) => (_ctx.isOpen = $event)),
    style: {"max-width":"unset!important"},
    contentClass: "modal-limit",
    modalWidth: _ctx.maxWidth
  }, {
    default: _withId(() => [
      _createVNode("form", {
        onSubmit: _cache[51] || (_cache[51] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
        novalidate: "",
        id: "businessReceiptsPayments"
      }, [
        _createVNode("div", {
          class: ["businessReceiptsPaymentsContent", { 'payment-container': _ctx.selectedStep != _ctx.receiptPaymentSteps.SelectType }]
        }, [
          (_ctx.selectedStep == _ctx.receiptPaymentSteps.SelectType)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('receiptType.selectAPaymentMethod')), 1),
                _createVNode("div", _hoisted_3, [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("div", {
                      class: ["action-btn with-word-spacing ", _ctx.paymentCreditCardExist ? 'action-grey' : 'action-blue'],
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeSelectedStep(_ctx.receiptPaymentSteps.CreditCard)))
                    }, [
                      _hoisted_5,
                      _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('receiptType.creditCard')), 1)
                    ], 2),
                    _createVNode("div", {
                      class: "action-btn with-word-spacing action-blue",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeSelectedStep(_ctx.receiptPaymentSteps.Cash)))
                    }, [
                      _hoisted_7,
                      _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('receiptType.cash')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", {
                      class: "action-btn with-word-spacing action-blue",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeSelectedStep(_ctx.receiptPaymentSteps.Check)))
                    }, [
                      _hoisted_10,
                      _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('receiptType.check')), 1)
                    ]),
                    _createVNode("div", {
                      class: "action-btn with-word-spacing action-blue",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeSelectedStep(_ctx.receiptPaymentSteps.BankTransfer)))
                    }, [
                      _hoisted_12,
                      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('receiptType.bankTransfer')), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedStep == _ctx.receiptPaymentSteps.CreditCard)
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('receiptType.creditCard')), 1),
                _createVNode("div", _hoisted_16, [
                  _createVNode("label", _hoisted_17, [
                    _createTextVNode(_toDisplayString(_ctx.creditCardPelecardPayment.isTerminalPaymentOnline ? _ctx.$t('label.online') : _ctx.$t('label.offline')) + " ", 1),
                    _withDirectives(_createVNode("input", {
                      disabled: _ctx.isTerminalPaymentOnline == false,
                      type: "checkbox",
                      class: "toggle",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.creditCardPelecardPayment.isTerminalPaymentOnline = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelCheckbox, _ctx.creditCardPelecardPayment.isTerminalPaymentOnline]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('label.amount')), 1),
                    _withDirectives(_createVNode("input", {
                      min: "0",
                      step: "0.01",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.creditCardPelecardPayment.total = $event)),
                      class: "receipt-payment-input-number p-inputtext",
                      type: "text",
                      required: "",
                      onKeypress: _cache[7] || (_cache[7] = ($event: any) => (_ctx.KeypressNumber($event))),
                      onPaste: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumbersDotMinus && _ctx.filterPastedOnlyNumbersDotMinus(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.creditCardPelecardPayment.total]
                    ])
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('priceList.currency')), 1),
                    _createVNode(_component_Multiselect, _mergeProps({
                      required: "",
                      modelValue: _ctx.creditCardPelecardPayment.currencyId,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.creditCardPelecardPayment.currencyId = $event))
                    }, _ctx.currenciesSelect, {
                      onChange: _ctx.currencyChanged,
                      class: "custom-multiselect-input currency"
                    }), {
                      caret: _withId(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    }, 16, ["modelValue", "onChange"])
                  ]),
                  (_ctx.creditCardPelecardPayment.currencyId != _ctx.localCurrencyId)
                    ? (_openBlock(), _createBlock("div", _hoisted_24, [
                        _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('receipt.rate')), 1),
                        _createVNode(_component_InputNumber, {
                          class: "receipt-payment-input-number",
                          min: 0,
                          allowEmpty: false,
                          required: "",
                          mode: "decimal",
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: _ctx.creditCardPelecardPayment.currencyRate,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.creditCardPelecardPayment.currencyRate = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_26, [
                    _createVNode("div", null, _toDisplayString(_ctx.formatAmount(_ctx.totalInLocal)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1)
                  ]),
                  (!_ctx.creditCardPelecardPayment.isTerminalPaymentOnline)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createVNode("div", _hoisted_27, [
                          _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('receiptCreditCard.holderName')), 1),
                          _withDirectives(_createVNode("input", {
                            class: "bookit-input w-100",
                            required: "",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.creditCardPelecardPayment.holderFullName = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.creditCardPelecardPayment.holderFullName]
                          ])
                        ]),
                        _createVNode("div", _hoisted_29, [
                          _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('label.holder-id-number')), 1),
                          _withDirectives(_createVNode("input", {
                            class: "bookit-input w-100",
                            onKeypress: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isNumber($event))),
                            required: "",
                            maxlength: "255",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.creditCardPelecardPayment.holderIdNumber = $event))
                          }, null, 544), [
                            [_vModelText, _ctx.creditCardPelecardPayment.holderIdNumber]
                          ])
                        ]),
                        _createVNode("div", _hoisted_31, [
                          _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('receiptCreditCard.lastFourDigits')), 1),
                          _withDirectives(_createVNode("input", {
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.creditCardPelecardPayment.lastFourDigits = $event)),
                            onKeypress: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isNumber($event))),
                            required: "",
                            class: "bookit-input w-100",
                            type: "text",
                            maxlength: "4",
                            minlength: "4",
                            min: "0"
                          }, null, 544), [
                            [_vModelText, _ctx.creditCardPelecardPayment.lastFourDigits]
                          ]),
                          _createVNode("span", _hoisted_33, [
                            _hoisted_34,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.lastFourDigits.required')), 1)
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_35, [
                    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('receiptCreditCard.payments')), 1),
                    _createVNode(_component_Multiselect, {
                      required: "",
                      modelValue: _ctx.creditCardPelecardPayment.numberOfPayments,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.creditCardPelecardPayment.numberOfPayments = $event)),
                      canDeselect: false,
                      options: [
                                    { value: 1, label: 1 },
                                    { value: 2, label: 2 },
                                    { value: 3, label: 3 }
                                ],
                      class: "custom-multiselect-input"
                    }, {
                      caret: _withId(() => [
                        _hoisted_37
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (!_ctx.creditCardPelecardPayment.numberOfPayments)
                      ? (_openBlock(), _createBlock("p", _hoisted_38, [
                          _hoisted_39,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedStep == _ctx.receiptPaymentSteps.Cash)
            ? (_openBlock(), _createBlock("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('receiptType.cash')), 1),
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('label.amount')), 1),
                    _withDirectives(_createVNode("input", {
                      min: "0",
                      step: "0.01",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.cashPayment.total = $event)),
                      class: "receipt-payment-input-number p-inputtext",
                      type: "text",
                      required: "",
                      onKeypress: _cache[18] || (_cache[18] = ($event: any) => (_ctx.KeypressNumber($event))),
                      onPaste: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumbersDotMinus && _ctx.filterPastedOnlyNumbersDotMinus(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.cashPayment.total]
                    ])
                  ]),
                  _createVNode("div", _hoisted_45, [
                    _createVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('priceList.currency')), 1),
                    _createVNode(_component_Multiselect, _mergeProps({
                      required: "",
                      modelValue: _ctx.cashPayment.currencyId,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.cashPayment.currencyId = $event))
                    }, _ctx.currenciesSelect, {
                      onChange: _ctx.currencyChanged,
                      class: "custom-multiselect-input currency"
                    }), {
                      caret: _withId(() => [
                        _hoisted_47
                      ]),
                      _: 1
                    }, 16, ["modelValue", "onChange"])
                  ]),
                  (_ctx.cashPayment.currencyId != _ctx.localCurrencyId)
                    ? (_openBlock(), _createBlock("div", _hoisted_48, [
                        _createVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('receipt.rate')), 1),
                        _createVNode(_component_InputNumber, {
                          class: "receipt-payment-input-number",
                          min: 0,
                          allowEmpty: false,
                          required: "",
                          mode: "decimal",
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: _ctx.cashPayment.currencyRate,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.cashPayment.currencyRate = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_50, [
                    _createVNode("div", null, _toDisplayString(_ctx.formatAmount(_ctx.totalInLocal)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedStep == _ctx.receiptPaymentSteps.Check)
            ? (_openBlock(), _createBlock("div", _hoisted_51, [
                _createVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('receiptType.check')), 1),
                _createVNode("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, [
                    _createVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('label.amount')), 1),
                    _withDirectives(_createVNode("input", {
                      min: "0",
                      step: "0.01",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.checkPayment.total = $event)),
                      class: "receipt-payment-input-number p-inputtext",
                      type: "text",
                      required: "",
                      onKeypress: _cache[23] || (_cache[23] = ($event: any) => (_ctx.KeypressNumber($event))),
                      onPaste: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumbersDotMinus && _ctx.filterPastedOnlyNumbersDotMinus(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.checkPayment.total]
                    ])
                  ]),
                  _createVNode("div", _hoisted_56, [
                    _createVNode("div", _hoisted_57, _toDisplayString(_ctx.$t('priceList.currency')), 1),
                    _createVNode(_component_Multiselect, _mergeProps({
                      required: "",
                      modelValue: _ctx.checkPayment.currencyId,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.checkPayment.currencyId = $event))
                    }, _ctx.currenciesSelect, {
                      onChange: _ctx.currencyChanged,
                      class: "custom-multiselect-input currency"
                    }), {
                      caret: _withId(() => [
                        _hoisted_58
                      ]),
                      _: 1
                    }, 16, ["modelValue", "onChange"])
                  ]),
                  (_ctx.checkPayment.currencyId != _ctx.localCurrencyId)
                    ? (_openBlock(), _createBlock("div", _hoisted_59, [
                        _createVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('receipt.rate')), 1),
                        _createVNode(_component_InputNumber, {
                          class: "receipt-payment-input-number",
                          min: 0,
                          allowEmpty: false,
                          required: "",
                          mode: "decimal",
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: _ctx.checkPayment.currencyRate,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.checkPayment.currencyRate = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_61, [
                    _createVNode("div", null, _toDisplayString(_ctx.formatAmount(_ctx.totalInLocal)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1)
                  ]),
                  _createVNode("div", _hoisted_62, [
                    _createVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('receipt.bank')), 1),
                    _createVNode(_component_Multiselect, {
                      label: "name",
                      modelValue: _ctx.checkPayment.bankId,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.checkPayment.bankId = $event)),
                      options: _ctx.banks,
                      canDeselect: false,
                      valueProp: "id",
                      required: "",
                      searchable: false,
                      class: "custom-multiselect-input"
                    }, {
                      caret: _withId(() => [
                        _hoisted_64
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"])
                  ]),
                  _createVNode("div", _hoisted_65, [
                    _createVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('receipt.branch')), 1),
                    _createVNode(_component_InputNumber, {
                      style: {"height":"48px"},
                      required: "",
                      allowEmpty: true,
                      max: 99999,
                      useGrouping: false,
                      class: "w-100",
                      modelValue: _ctx.checkPayment.bankBranchNumber,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.checkPayment.bankBranchNumber = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode("div", _hoisted_67, [
                    _createVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('provider.accounting.number')), 1),
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.checkPayment.accountNumber = $event)),
                      onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.checkPaymentIsNumber('accountNumber', $event))),
                      required: "",
                      class: "bookit-input w-100",
                      type: "text",
                      maxlength: "64",
                      onKeypress: _cache[31] || (_cache[31] = ($event: any) => (_ctx.isNumber($event)))
                    }, null, 544), [
                      [_vModelText, _ctx.checkPayment.accountNumber]
                    ])
                  ]),
                  _createVNode("div", _hoisted_69, [
                    _createVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('receiptCheck.checkNumber')), 1),
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.checkPayment.checkNumber = $event)),
                      onInput: _cache[33] || (_cache[33] = ($event: any) => (_ctx.checkPaymentIsNumber('checkNumber', $event))),
                      required: "",
                      class: "bookit-input w-100",
                      type: "text",
                      maxlength: "64",
                      onKeypress: _cache[34] || (_cache[34] = ($event: any) => (_ctx.isNumber($event)))
                    }, null, 544), [
                      [_vModelText, _ctx.checkPayment.checkNumber]
                    ])
                  ]),
                  _createVNode("div", _hoisted_71, [
                    _createVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('receipt.valueDate')) + ":", 1),
                    _createVNode(_component_Calendar, {
                      required: "",
                      dateFormat: _ctx.dateConstants.CALENDAR_DATE_FORMAT,
                      modelValue: _ctx.checkPaymentValueDate,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.checkPaymentValueDate = $event)),
                      selectionMode: "single"
                    }, null, 8, ["dateFormat", "modelValue"]),
                    _createVNode("span", _hoisted_73, [
                      _hoisted_74,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_75, [
                    _createVNode("div", _hoisted_76, _toDisplayString(_ctx.$t('label.check-owner')), 1),
                    _withDirectives(_createVNode("input", {
                      class: "bookit-input w-100",
                      maxlength: "30",
                      required: "",
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.checkPayment.owner = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.checkPayment.owner]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedStep == _ctx.receiptPaymentSteps.BankTransfer)
            ? (_openBlock(), _createBlock("div", _hoisted_77, [
                _createVNode("div", _hoisted_78, _toDisplayString(_ctx.$t('receiptType.bankTransfer')), 1),
                _createVNode("div", _hoisted_79, [
                  _createVNode("div", _hoisted_80, [
                    _createVNode("div", _hoisted_81, _toDisplayString(_ctx.$t('label.amount')), 1),
                    _withDirectives(_createVNode("input", {
                      min: "0",
                      step: "0.01",
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.bankTransferPayment.total = $event)),
                      class: "receipt-payment-input-number p-inputtext",
                      type: "text",
                      required: "",
                      onKeypress: _cache[38] || (_cache[38] = ($event: any) => (_ctx.KeypressNumber($event))),
                      onPaste: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumbersDotMinus && _ctx.filterPastedOnlyNumbersDotMinus(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.bankTransferPayment.total]
                    ])
                  ]),
                  _createVNode("div", _hoisted_82, [
                    _createVNode("div", _hoisted_83, _toDisplayString(_ctx.$t('priceList.currency')), 1),
                    _createVNode(_component_Multiselect, _mergeProps({
                      required: "",
                      modelValue: _ctx.bankTransferPayment.currencyId,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.bankTransferPayment.currencyId = $event))
                    }, _ctx.currenciesSelect, {
                      onChange: _ctx.currencyChanged,
                      class: "custom-multiselect-input currency"
                    }), {
                      caret: _withId(() => [
                        _hoisted_84
                      ]),
                      _: 1
                    }, 16, ["modelValue", "onChange"])
                  ]),
                  (_ctx.bankTransferPayment.currencyId != _ctx.localCurrencyId)
                    ? (_openBlock(), _createBlock("div", _hoisted_85, [
                        _createVNode("div", _hoisted_86, _toDisplayString(_ctx.$t('receipt.rate')), 1),
                        _createVNode(_component_InputNumber, {
                          class: "receipt-payment-input-number",
                          min: 0,
                          allowEmpty: false,
                          required: "",
                          mode: "decimal",
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: _ctx.bankTransferPayment.currencyRate,
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.bankTransferPayment.currencyRate = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_87, [
                    _createVNode("div", null, _toDisplayString(_ctx.formatAmount(_ctx.totalInLocal)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1)
                  ]),
                  _createVNode("div", _hoisted_88, [
                    _createVNode("div", _hoisted_89, _toDisplayString(_ctx.$t('receipt.bank')), 1),
                    _createVNode(_component_Multiselect, {
                      label: "name",
                      modelValue: _ctx.bankTransferPayment.bankId,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.bankTransferPayment.bankId = $event)),
                      options: _ctx.banks,
                      canDeselect: false,
                      valueProp: "id",
                      searchable: false,
                      class: "custom-multiselect-input"
                    }, {
                      caret: _withId(() => [
                        _hoisted_90
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"])
                  ]),
                  _createVNode("div", _hoisted_91, [
                    _createVNode("div", _hoisted_92, _toDisplayString(_ctx.$t('receipt.branch')), 1),
                    _createVNode(_component_InputNumber, {
                      style: {"height":"48px"},
                      allowEmpty: true,
                      max: 99999,
                      useGrouping: false,
                      class: "w-100",
                      modelValue: _ctx.bankTransferPayment.bankBranchNumber,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.bankTransferPayment.bankBranchNumber = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode("div", _hoisted_93, [
                    _createVNode("div", _hoisted_94, _toDisplayString(_ctx.$t('receiptCheck.account')), 1),
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.bankTransferPayment.accountNumber = $event)),
                      onInput: _cache[45] || (_cache[45] = ($event: any) => (_ctx.bankTransferPaymentIsNumber('accountNumber', $event))),
                      class: "bookit-input w-100",
                      type: "text",
                      maxlength: "64",
                      onKeypress: _cache[46] || (_cache[46] = ($event: any) => (_ctx.isNumber($event)))
                    }, null, 544), [
                      [_vModelText, _ctx.bankTransferPayment.accountNumber]
                    ])
                  ]),
                  _createVNode("div", _hoisted_95, [
                    _createVNode("div", _hoisted_96, _toDisplayString(_ctx.$t('provider.account')), 1),
                    _createVNode(_component_Multiselect, {
                      label: "name",
                      modelValue: _ctx.bankTransferPayment.providerAccountId,
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.bankTransferPayment.providerAccountId = $event)),
                      options: _ctx.providerAccountsByCurrency,
                      canDeselect: false,
                      valueProp: "id",
                      searchable: false,
                      onChange: _ctx.providerAccountChanged,
                      class: "custom-multiselect-input"
                    }, {
                      caret: _withId(() => [
                        _hoisted_97
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options", "onChange"])
                  ]),
                  _createVNode("div", _hoisted_98, [
                    _createVNode("div", _hoisted_99, _toDisplayString(_ctx.$t('receipt.valueDate')) + ":", 1),
                    _createVNode(_component_Calendar, {
                      required: "",
                      dateFormat: _ctx.dateConstants.CALENDAR_DATE_FORMAT,
                      modelValue: _ctx.bankTransferPaymentValueDate,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.bankTransferPaymentValueDate = $event)),
                      selectionMode: "single"
                    }, null, 8, ["dateFormat", "modelValue"]),
                    _createVNode("span", _hoisted_100, [
                      _hoisted_101,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_102, [
                    _createVNode("div", _hoisted_103, _toDisplayString(_ctx.$t('receiptBankTransfer.reference')), 1),
                    _withDirectives(_createVNode("input", {
                      required: "",
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.bankTransferPayment.referenceNumber = $event)),
                      class: "bookit-input w-100",
                      type: "text",
                      maxlength: "50"
                    }, null, 512), [
                      [_vModelText, _ctx.bankTransferPayment.referenceNumber]
                    ]),
                    _createVNode("span", _hoisted_104, [
                      _hoisted_105,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedStep != _ctx.receiptPaymentSteps.SelectType)
            ? (_openBlock(), _createBlock("div", _hoisted_106, [
                _createVNode("button", _hoisted_107, _toDisplayString(_ctx.$t('button.add')), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_108, [
            _createVNode("button", {
              class: "payment-action-close",
              type: "button",
              onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, _toDisplayString(_ctx.$t('button.close')), 1)
          ])
        ], 2)
      ], 32)
    ]),
    _: 1
  }, 8, ["isOpen", "modalWidth"]))
})